var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tab-msc" } },
    [
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { width: "400px", height: "300px" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { height: "100%" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "112px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "title",
                      attrs: { title: _vm.$t("SeaExport.BookingInfo") }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BookingInfo")))]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "MST Booking" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "mstBooking" },
                        model: {
                          value: _vm.mscData.mstBooking,
                          callback: function($$v) {
                            _vm.$set(_vm.mscData, "mstBooking", $$v)
                          },
                          expression: "mscData.mstBooking"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "ContractRateMode" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            no: "contractRateMode",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini",
                            clearable: ""
                          },
                          model: {
                            value: _vm.mscData.contractRateMode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "contractRateMode", $$v)
                            },
                            expression: "mscData.contractRateMode"
                          }
                        },
                        _vm._l(
                          _vm.SystemConstants.CONTRACT_RATE_MODE_LIST,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-checkbox", {
                          attrs: { no: "freightBl", label: "Freight BL" },
                          model: {
                            value: _vm.mscData.freightBl,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "freightBl", $$v)
                            },
                            expression: "mscData.freightBl"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "podAgency", label: "POD Agency" },
                          model: {
                            value: _vm.mscData.podAgency,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "podAgency", $$v)
                            },
                            expression: "mscData.podAgency"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { width: "420px", height: "300px" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { height: "100%" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "180px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "title",
                      attrs: { title: _vm.$t("SeaExport.TransportInfo") }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.TransportInfo")))]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Place0fReceiptCY" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "place0fReceiptCy" },
                        model: {
                          value: _vm.mscData.place0fReceiptCy,
                          callback: function($$v) {
                            _vm.$set(_vm.mscData, "place0fReceiptCy", $$v)
                          },
                          expression: "mscData.place0fReceiptCy"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Place0fReceiptShippingMode" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            no: "place0fReceiptShippingMode",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini",
                            clearable: ""
                          },
                          model: {
                            value: _vm.mscData.place0fReceiptShippingMode,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.mscData,
                                "place0fReceiptShippingMode",
                                $$v
                              )
                            },
                            expression: "mscData.place0fReceiptShippingMode"
                          }
                        },
                        _vm._l(_vm.transportationModeInfos, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.englishName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Final Dest" } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "finalDest",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.mscData.finalDest,
                          "tag-name": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.mscData.finalDest = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "FNL SubLoc" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "fnlSubLoc" },
                        model: {
                          value: _vm.mscData.fnlSubLoc,
                          callback: function($$v) {
                            _vm.$set(_vm.mscData, "fnlSubLoc", $$v)
                          },
                          expression: "mscData.fnlSubLoc"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "FNL TM" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "fnlTm" },
                        model: {
                          value: _vm.mscData.fnlTm,
                          callback: function($$v) {
                            _vm.$set(_vm.mscData, "fnlTm", $$v)
                          },
                          expression: "mscData.fnlTm"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Comment" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "comment" },
                        model: {
                          value: _vm.mscData.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.mscData, "comment", $$v)
                          },
                          expression: "mscData.comment"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Destination Zip Code" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "destinationZipCode" },
                        model: {
                          value: _vm.mscData.destinationZipCode,
                          callback: function($$v) {
                            _vm.$set(_vm.mscData, "destinationZipCode", $$v)
                          },
                          expression: "mscData.destinationZipCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "section", staticStyle: { width: "1800px" } },
          [
            _c(
              "span",
              {
                staticClass: "title",
                attrs: {
                  title: _vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo"))
                )
              ]
            ),
            _c(
              "div",
              [
                _c(
                  "el-dropdown",
                  {
                    class: _vm.readonly ? "not-click" : "",
                    attrs: { no: "1", "split-button": "", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.commandHandle(_vm.command1)
                      },
                      command: function(p) {
                        _vm.command1 = p
                        _vm.commandHandle(_vm.command1)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.command1) + " "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CodeSearching")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CodeSearching")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CopyFromTheLastTime")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyFromTheLastTime")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CopyFromOtherBill")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyFromOtherBill")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "form-row",
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row",
                  "margin-top": "8px"
                }
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { "label-width": "120px", "label-position": "right" }
                  },
                  [
                    _c("el-form-item", {
                      attrs: { label: _vm.$t("SeaExport.Shipper") }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: "VIP CODE" } },
                      [
                        _c("cargo-input", {
                          staticStyle: { width: "220px" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperVipCode"
                          },
                          model: {
                            value: _vm.mscData.shipperVipCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "shipperVipCode", $$v)
                            },
                            expression: "mscData.shipperVipCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "MSC CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperMscCode"
                          },
                          model: {
                            value: _vm.mscData.shipperMscCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "shipperMscCode", $$v)
                            },
                            expression: "mscData.shipperMscCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "COMPANY CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperCompanyCode"
                          },
                          model: {
                            value: _vm.mscData.shipperCompanyCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "shipperCompanyCode", $$v)
                            },
                            expression: "mscData.shipperCompanyCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "INTTRA CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperInttraCode"
                          },
                          model: {
                            value: _vm.mscData.shipperInttraCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "shipperInttraCode", $$v)
                            },
                            expression: "mscData.shipperInttraCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Other Info" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperOtherInfo"
                          },
                          model: {
                            value: _vm.mscData.shipperOtherInfo,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "shipperOtherInfo", $$v)
                            },
                            expression: "mscData.shipperOtherInfo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Use BL" } },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperUseBl",
                            label: " "
                          },
                          on: {
                            change: function($event) {
                              return _vm.useBlChange(1)
                            }
                          },
                          model: {
                            value: _vm.mscData.shipperUseBl,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "shipperUseBl", $$v)
                            },
                            expression: "mscData.shipperUseBl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.shipperUseBl,
                            expression: "mscData.shipperUseBl"
                          }
                        ],
                        attrs: { label: "BL Company" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperBlCompany"
                          },
                          model: {
                            value: _vm.mscData.shipperBlCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "shipperBlCompany", $$v)
                            },
                            expression: "mscData.shipperBlCompany"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.shipperUseBl,
                            expression: "mscData.shipperUseBl"
                          }
                        ],
                        attrs: { label: "BL Address" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperBlAddress"
                          },
                          model: {
                            value: _vm.mscData.shipperBlAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "shipperBlAddress", $$v)
                            },
                            expression: "mscData.shipperBlAddress"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.shipperUseBl,
                            expression: "mscData.shipperUseBl"
                          }
                        ],
                        attrs: { label: "BL Contact" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperBlContact"
                          },
                          model: {
                            value: _vm.mscData.shipperBlContact,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "shipperBlContact", $$v)
                            },
                            expression: "mscData.shipperBlContact"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: { "margin-right": "20px" },
                    attrs: { "label-width": "120px", "label-position": "right" }
                  },
                  [
                    _c("el-form-item", {
                      attrs: { label: _vm.$t("SeaExport.Consignee") }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: "VIP CODE" } },
                      [
                        _c("cargo-input", {
                          staticStyle: { width: "220px" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeVipCode"
                          },
                          model: {
                            value: _vm.mscData.consigneeVipCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "consigneeVipCode", $$v)
                            },
                            expression: "mscData.consigneeVipCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "MSC CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeMscCode"
                          },
                          model: {
                            value: _vm.mscData.consigneeMscCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "consigneeMscCode", $$v)
                            },
                            expression: "mscData.consigneeMscCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "COMPANY CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeCompanyCode"
                          },
                          model: {
                            value: _vm.mscData.consigneeCompanyCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "consigneeCompanyCode", $$v)
                            },
                            expression: "mscData.consigneeCompanyCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "INTTRA CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeInttraCode"
                          },
                          model: {
                            value: _vm.mscData.consigneeInttraCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "consigneeInttraCode", $$v)
                            },
                            expression: "mscData.consigneeInttraCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Other Info" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeOtherInfo"
                          },
                          model: {
                            value: _vm.mscData.consigneeOtherInfo,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "consigneeOtherInfo", $$v)
                            },
                            expression: "mscData.consigneeOtherInfo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Use BL" } },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeUseBl",
                            label: " "
                          },
                          on: {
                            change: function($event) {
                              return _vm.useBlChange(2)
                            }
                          },
                          model: {
                            value: _vm.mscData.consigneeUseBl,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "consigneeUseBl", $$v)
                            },
                            expression: "mscData.consigneeUseBl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.consigneeUseBl,
                            expression: "mscData.consigneeUseBl"
                          }
                        ],
                        attrs: { label: "BL Company" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeBlCompany"
                          },
                          model: {
                            value: _vm.mscData.consigneeBlCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "consigneeBlCompany", $$v)
                            },
                            expression: "mscData.consigneeBlCompany"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.consigneeUseBl,
                            expression: "mscData.consigneeUseBl"
                          }
                        ],
                        attrs: { label: "BL Address" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeBlAddress"
                          },
                          model: {
                            value: _vm.mscData.consigneeBlAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "consigneeBlAddress", $$v)
                            },
                            expression: "mscData.consigneeBlAddress"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.consigneeUseBl,
                            expression: "mscData.consigneeUseBl"
                          }
                        ],
                        attrs: { label: "BL Contact" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeBlContact"
                          },
                          model: {
                            value: _vm.mscData.consigneeBlContact,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "consigneeBlContact", $$v)
                            },
                            expression: "mscData.consigneeBlContact"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: { "margin-right": "20px" },
                    attrs: { "label-width": "120px", "label-position": "right" }
                  },
                  [
                    _c("el-form-item", {
                      attrs: { label: _vm.$t("SeaExport.NotifyParty") }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: "VIP CODE" } },
                      [
                        _c("cargo-input", {
                          staticStyle: { width: "220px" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyVipCode"
                          },
                          model: {
                            value: _vm.mscData.notifyVipCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "notifyVipCode", $$v)
                            },
                            expression: "mscData.notifyVipCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "MSC CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyMscCode"
                          },
                          model: {
                            value: _vm.mscData.notifyMscCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "notifyMscCode", $$v)
                            },
                            expression: "mscData.notifyMscCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "COMPANY CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyCompanyCode"
                          },
                          model: {
                            value: _vm.mscData.notifyCompanyCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "notifyCompanyCode", $$v)
                            },
                            expression: "mscData.notifyCompanyCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "INTTRA CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyInttraCode"
                          },
                          model: {
                            value: _vm.mscData.notifyInttraCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "notifyInttraCode", $$v)
                            },
                            expression: "mscData.notifyInttraCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Other Info" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyOtherInfo"
                          },
                          model: {
                            value: _vm.mscData.notifyOtherInfo,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "notifyOtherInfo", $$v)
                            },
                            expression: "mscData.notifyOtherInfo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Use BL" } },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyUseBl",
                            label: " "
                          },
                          on: {
                            change: function($event) {
                              return _vm.useBlChange(3)
                            }
                          },
                          model: {
                            value: _vm.mscData.notifyUseBl,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "notifyUseBl", $$v)
                            },
                            expression: "mscData.notifyUseBl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.notifyUseBl,
                            expression: "mscData.notifyUseBl"
                          }
                        ],
                        attrs: { label: "BL Company" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyBlCompany"
                          },
                          model: {
                            value: _vm.mscData.notifyBlCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "notifyBlCompany", $$v)
                            },
                            expression: "mscData.notifyBlCompany"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.notifyUseBl,
                            expression: "mscData.notifyUseBl"
                          }
                        ],
                        attrs: { label: "BL Address" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyBlAddress"
                          },
                          model: {
                            value: _vm.mscData.notifyBlAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "notifyBlAddress", $$v)
                            },
                            expression: "mscData.notifyBlAddress"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.notifyUseBl,
                            expression: "mscData.notifyUseBl"
                          }
                        ],
                        attrs: { label: "BL Contact" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyBlContact"
                          },
                          model: {
                            value: _vm.mscData.notifyBlContact,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "notifyBlContact", $$v)
                            },
                            expression: "mscData.notifyBlContact"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "form-row",
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row",
                  "margin-top": "8px"
                }
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { "label-width": "120px", "label-position": "right" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "0", label: " " } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "120px" },
                                attrs: {
                                  disabled: _vm.readonly,
                                  no: "alsoNotifyCode"
                                },
                                model: {
                                  value: _vm.mscData.alsoNotifyCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.mscData, "alsoNotifyCode", $$v)
                                  },
                                  expression: "mscData.alsoNotifyCode"
                                }
                              },
                              _vm._l(_vm.otherFieldsData, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "VIP CODE" } },
                      [
                        _c("cargo-input", {
                          staticStyle: { width: "220px" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "alsoNotifyVipCode"
                          },
                          model: {
                            value: _vm.mscData.alsoNotifyVipCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "alsoNotifyVipCode", $$v)
                            },
                            expression: "mscData.alsoNotifyVipCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "MSC CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "alsoNotifyMscCode"
                          },
                          model: {
                            value: _vm.mscData.alsoNotifyMscCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "alsoNotifyMscCode", $$v)
                            },
                            expression: "mscData.alsoNotifyMscCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "COMPANY CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "alsoNotifyCompanyCode"
                          },
                          model: {
                            value: _vm.mscData.alsoNotifyCompanyCode,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.mscData,
                                "alsoNotifyCompanyCode",
                                $$v
                              )
                            },
                            expression: "mscData.alsoNotifyCompanyCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "INTTRA CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "alsoNotifyInttraCode"
                          },
                          model: {
                            value: _vm.mscData.alsoNotifyInttraCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "alsoNotifyInttraCode", $$v)
                            },
                            expression: "mscData.alsoNotifyInttraCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Other Info" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "alsoNotifyOtherInfo"
                          },
                          model: {
                            value: _vm.mscData.alsoNotifyOtherInfo,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "alsoNotifyOtherInfo", $$v)
                            },
                            expression: "mscData.alsoNotifyOtherInfo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Use BL" } },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "alsoNotifyUseBl",
                            label: " "
                          },
                          on: {
                            change: function($event) {
                              return _vm.useBlChange(4)
                            }
                          },
                          model: {
                            value: _vm.mscData.alsoNotifyUseBl,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "alsoNotifyUseBl", $$v)
                            },
                            expression: "mscData.alsoNotifyUseBl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.alsoNotifyUseBl,
                            expression: "mscData.alsoNotifyUseBl"
                          }
                        ],
                        attrs: { label: "BL Company" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "alsoNotifyBlCompany"
                          },
                          model: {
                            value: _vm.mscData.alsoNotifyBlCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "alsoNotifyBlCompany", $$v)
                            },
                            expression: "mscData.alsoNotifyBlCompany"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.alsoNotifyUseBl,
                            expression: "mscData.alsoNotifyUseBl"
                          }
                        ],
                        attrs: { label: "BL Address" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "alsoNotifyBlAddress"
                          },
                          model: {
                            value: _vm.mscData.alsoNotifyBlAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "alsoNotifyBlAddress", $$v)
                            },
                            expression: "mscData.alsoNotifyBlAddress"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.alsoNotifyUseBl,
                            expression: "mscData.alsoNotifyUseBl"
                          }
                        ],
                        attrs: { label: "BL Contact" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "alsoNotifyBlContact"
                          },
                          model: {
                            value: _vm.mscData.alsoNotifyBlContact,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "alsoNotifyBlContact", $$v)
                            },
                            expression: "mscData.alsoNotifyBlContact"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: { "margin-right": "20px" },
                    attrs: { "label-width": "120px", "label-position": "right" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_Payment1") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex", width: "100%" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "paymentCode"
                              },
                              model: {
                                value: _vm.mscData.paymentCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.mscData, "paymentCode", $$v)
                                },
                                expression: "mscData.paymentCode"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "BringInData",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.paymentImportData(true)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_BringInData")) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "VIP CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "paymentVipCode"
                          },
                          model: {
                            value: _vm.mscData.paymentVipCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "paymentVipCode", $$v)
                            },
                            expression: "mscData.paymentVipCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "MSC CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "paymentMscCode"
                          },
                          model: {
                            value: _vm.mscData.paymentMscCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "paymentMscCode", $$v)
                            },
                            expression: "mscData.paymentMscCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "COMPANY CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "paymentCompanyCode"
                          },
                          model: {
                            value: _vm.mscData.paymentCompanyCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "paymentCompanyCode", $$v)
                            },
                            expression: "mscData.paymentCompanyCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "INTTRA CODE" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "paymentInttraCode"
                          },
                          model: {
                            value: _vm.mscData.paymentInttraCode,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "paymentInttraCode", $$v)
                            },
                            expression: "mscData.paymentInttraCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Other Info" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "paymentOtherInfo"
                          },
                          model: {
                            value: _vm.mscData.paymentOtherInfo,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "paymentOtherInfo", $$v)
                            },
                            expression: "mscData.paymentOtherInfo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Use BL" } },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "paymentUseBl",
                            label: " "
                          },
                          on: {
                            change: function($event) {
                              return _vm.useBlChange(5)
                            }
                          },
                          model: {
                            value: _vm.mscData.paymentUseBl,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "paymentUseBl", $$v)
                            },
                            expression: "mscData.paymentUseBl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.paymentUseBl,
                            expression: "mscData.paymentUseBl"
                          }
                        ],
                        attrs: { label: "BL Company" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "paymentBlCompany"
                          },
                          model: {
                            value: _vm.mscData.paymentBlCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "paymentBlCompany", $$v)
                            },
                            expression: "mscData.paymentBlCompany"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.paymentUseBl,
                            expression: "mscData.paymentUseBl"
                          }
                        ],
                        attrs: { label: "BL Address" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "paymentBlAddress"
                          },
                          model: {
                            value: _vm.mscData.paymentBlAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "paymentBlAddress", $$v)
                            },
                            expression: "mscData.paymentBlAddress"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mscData.paymentUseBl,
                            expression: "mscData.paymentUseBl"
                          }
                        ],
                        attrs: { label: "BL Contact" }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "paymentBlContact"
                          },
                          model: {
                            value: _vm.mscData.paymentBlContact,
                            callback: function($$v) {
                              _vm.$set(_vm.mscData, "paymentBlContact", $$v)
                            },
                            expression: "mscData.paymentBlContact"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ]),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          params: _vm.billAddressDialog.params,
          job: _vm.job,
          "show-payment": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: function(p) {
            _vm.codeSearchCallback(p, true)
          }
        }
      }),
      _c("msc-search-dialog", {
        attrs: {
          visible: _vm.searchBillNoDialog.visible,
          params: _vm.searchBillNoDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.selectionItemHandler(p)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }